// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"55a90ed9","956":"e2d94d9d"}[chunkId] + ".chunk.js";
};